<template>
    <div class="flex truncate" v-bind="$attrs" v-on="$listeners">
        <vx-basic-icon v-if="!hideIcon" class="mr-3" icon="MailIcon"></vx-basic-icon>

        <template v-if="hasEmail && isValid">
            <span v-if="noLink">
                {{ parsedEmail }}
            </span>
            <a v-else :href="`mailto:${parsedEmail}`">
                {{ parsedEmail }}
            </a>
        </template>

        <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
            {{ parsedEmail }}
            <span v-if="!isValid">*</span>
        </span>
    </div>
</template>

<script>
const EMAIL_REGEX =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
    name: 'vx-email',
    props: {
        value: {
            type: String
        },
        htmlTag: {
            type: String,
            default: 'span'
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        noLink: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasEmail() {
            return !!this.value
        },
        parsedEmail() {
            if (this.hasEmail) {
                return this.value.toLowerCase()
            } else {
                return 'No email'
            }
        },
        isValid() {
            return EMAIL_REGEX.test(this.parsedEmail)
        }
    }
}
</script>

<style></style>
